(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
class StickyHeader extends HTMLElement {
constructor() {
super();
}

connectedCallback() {
this.header = document.querySelector('.section-header');
this.headerIsAlwaysSticky =
this.getAttribute('data-sticky-type') === 'always' ||
this.getAttribute('data-sticky-type') === 'reduce-logo-size';
this.headerBounds = {};

this.setHeaderHeight();

window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

if (this.headerIsAlwaysSticky) {
this.header.classList.add('shopify-section-header-sticky');
}

this.currentScrollTop = 0;
this.preventReveal = false;
this.predictiveSearch = this.querySelector('predictive-search');

this.onScrollHandler = this.onScroll.bind(this);
this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
window.addEventListener('scroll', this.onScrollHandler, false);

this.createObserver();
}

setHeaderHeight() {
document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
}

disconnectedCallback() {
this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
window.removeEventListener('scroll', this.onScrollHandler);
}

createObserver() {
let observer = new IntersectionObserver((entries, observer) => {
this.headerBounds = entries[0].intersectionRect;
observer.disconnect();
});

observer.observe(this.header);
}

onScroll() {
const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
this.header.classList.add('scrolled-past-header');


if (this.preventHide) return;

requestAnimationFrame(this.hide.bind(this));


} else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
this.header.classList.add('scrolled-past-header');


if (!this.preventReveal) {
  requestAnimationFrame(this.reveal.bind(this));
} else {
  window.clearTimeout(this.isScrolling);

  this.isScrolling = setTimeout(() => {
    this.preventReveal = false;
  }, 66);

  requestAnimationFrame(this.hide.bind(this));
}

} else if (scrollTop <= this.headerBounds.top) {
this.header.classList.remove('scrolled-past-header');
requestAnimationFrame(this.reset.bind(this));
}

this.currentScrollTop = scrollTop;
}

hide() {
if (this.headerIsAlwaysSticky) return;

this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
this.closeMenuDisclosure();
this.closeSearchModal();
}

reveal() {
if (this.headerIsAlwaysSticky) return;

this.header.classList.add('shopify-section-header-sticky', 'animate');
this.header.classList.remove('shopify-section-header-hidden');
}

reset() {
if (this.headerIsAlwaysSticky) return;

this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
}

closeMenuDisclosure() {
this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
this.disclosures.forEach((disclosure) => disclosure.close());
}

closeSearchModal() {
this.searchModal = this.searchModal || this.header.querySelector('details-modal');
this.searchModal.close(false);
}
}

customElements.define('sticky-header', StickyHeader);

document.addEventListener('DOMContentLoaded', () => {
const isDesktop = () => window.matchMedia('(min-width: 990px)').matches;

const headerWrapper = document.querySelector('.header-wrapper');
const panel = document.getElementById('unified-submenu-panel');

if (!headerWrapper || !panel) return;

const topMenuItems = headerWrapper.querySelectorAll('.header__inline-menu > ul > li');

let closeTimer = null;
let activeMenuItem = null;

const calcMenuOffset = (menuItem) => {
if (!menuItem) return 0;

const wrapperRect = headerWrapper.getBoundingClientRect();
const itemRect = menuItem.getBoundingClientRect();

return Math.max(0, itemRect.left - wrapperRect.left);
};

const closeNativeDetails = () => {
topMenuItems.forEach((menuItem) => {
const details = menuItem.querySelector('details');


if (details) details.open = false;


});
};

const buildPanel = (menuItem) => {
panel.innerHTML = '';

if (!menuItem) return false;

const submenu = menuItem.querySelector('.header__submenu');

if (!submenu) return false;

const links = submenu.querySelectorAll('a');

if (!links.length) return false;

const offset = calcMenuOffset(menuItem);
panel.style.paddingLeft = offset + 'px';

const col = document.createElement('div');
col.className = 'unified-submenu-col';

links.forEach((link) => {
const a = document.createElement('a');
a.href = link.href;

let linkText = link.textContent.trim();

if (linkText === 'Familybag') {
  linkText = 'Family Bag';
} else if (linkText === 'Family社群') {
  linkText = 'Family 社群';
}

a.textContent = linkText;
col.appendChild(a);
});

panel.appendChild(col);

return true;
};

const cancelClose = () => {
if (!closeTimer) return;

clearTimeout(closeTimer);
closeTimer = null;
};

const closePanelNow = () => {
cancelClose();

panel.classList.remove('is-visible');
headerWrapper.classList.remove('is-all-submenus-open');

activeMenuItem = null;

closeNativeDetails();
};

const closePanel = () => {
cancelClose();

closeTimer = setTimeout(() => {
closePanelNow();
}, 120);
};

const openPanel = (menuItem) => {
if (!isDesktop()) return;

cancelClose();
closeNativeDetails();

if (!buildPanel(menuItem)) {
closePanelNow();
return;
}

activeMenuItem = menuItem;

panel.classList.add('is-visible');
headerWrapper.classList.add('is-all-submenus-open');
};

topMenuItems.forEach((menuItem) => {
const summary = menuItem.querySelector('summary.header__menu-item');
const directLink = menuItem.querySelector(':scope > a.header__menu-item');

menuItem.addEventListener('mouseenter', () => {
if (!isDesktop()) return;

openPanel(menuItem);

});

if (summary) {
summary.addEventListener('click', (event) => {
if (!isDesktop()) return;

  event.preventDefault();
  event.stopPropagation();

  const details = menuItem.querySelector('details');

  if (details) details.open = false;

  openPanel(menuItem);
}, true);

}

if (directLink) {
directLink.addEventListener('mouseenter', () => {
if (!isDesktop()) return;

  closePanelNow();
});

directLink.addEventListener('click', () => {
  if (isDesktop()) closePanelNow();
});

}
});

headerWrapper.addEventListener('mouseenter', cancelClose);
headerWrapper.addEventListener('mouseleave', closePanel);

panel.addEventListener('mouseenter', cancelClose);
panel.addEventListener('mouseleave', closePanel);

document.addEventListener('click', (event) => {
if (!isDesktop()) return;

if (!headerWrapper.contains(event.target)) {
closePanelNow();
}
});

window.addEventListener('resize', () => {
if (panel.classList.contains('is-visible') && activeMenuItem) {
const offset = calcMenuOffset(activeMenuItem);
panel.style.paddingLeft = offset + 'px';
}
});

window.matchMedia('(max-width: 989px)').addEventListener('change', (event) => {
if (event.matches) {
closePanelNow();
}
});
});

document.addEventListener('DOMContentLoaded', () => {
/*
 * 手机端不需要国家/地区选择器：直接删除它的 DOM，
 * 只保留一个真正用于中英文切换的语言选择器。
 * PC 端不执行此逻辑。
 */
const removeMobileCountrySelector = () => {
  const mobileCountryForms = document.querySelectorAll(
    '.menu-drawer__localization form[id*="Country"]'
  );

  mobileCountryForms.forEach((countryForm) => {
    const localizationElement = countryForm.closest('localization-form');

    if (localizationElement) {
      localizationElement.remove();
    } else {
      countryForm.remove();
    }
  });
};

const mobileLocalizationQuery = window.matchMedia('(max-width: 989px)');

if (mobileLocalizationQuery.matches) {
  removeMobileCountrySelector();
}

mobileLocalizationQuery.addEventListener('change', (event) => {
  if (event.matches) removeMobileCountrySelector();
});

const localizationForms = document.querySelectorAll('.localization-form');

if (localizationForms.length === 0) return;

localizationForms.forEach((form) => {
const forceLabel = () => {
const selectBtn = form.querySelector('.localization-form__select');

if (!selectBtn) return;

const caret = selectBtn.querySelector('svg');

selectBtn.innerHTML = '<span>EN/CN</span>';

if (caret) {
  selectBtn.appendChild(caret);
}

};

forceLabel();

form.addEventListener('change', forceLabel);

document.addEventListener(
'toggle',
(event) => {
if (!form.contains(event.target)) return;

  forceLabel();
},
true

);
});
});

  } catch(e) { console.error(e); }
})();
})();
